import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

export const getCustomerDefaultSettingsEffect = ({
  customerKey,
  type,
  parameterName,
}: {
  customerKey: number;
  type?: string;
  parameterName?: string;
}) => {
  return axiosInstance.request({
    data: {
      customerKey,
      parameterName,
      type,
    },
    method: 'post',
    url: `${API.MASTER_SETTINGS}/GetCustomerDefaultSettings`,
  });
};
